export default __webpack_public_path__ + "static/media/hands.c1338a20.svg";